import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatEditGenerated.meta';

export type UseTrackAgentChatEditGeneratedParams = {
  width: number;
  height: number;
  content_type: string;
  canvas_id: string;
  thread_id?: string;
  is_auto?: boolean;
  model_selected_manually?: string;
};

export const useTrackAgentChatEditGenerated = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatEditGenerated = useCallback(
    (params: UseTrackAgentChatEditGeneratedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatEditGenerated };
};
